// Avancement d'une demande auto (PER-2428) : « commencée » tant que la
// première étape du formulaire n'est pas terminée, « à finaliser » quand elle
// l'est (isEstimated côté API), « finalisée » quand la seconde étape (devis
// prêt à signer) est terminée. Le mot « estimation » est réservé à la prime :
// la première étape ne garantit pas qu'une estimation a été faite (13/10/2026).
// Même règle que le bandeau d'état de « Infos et documents ».
export const PROGRESSIONS = {
  en_cours: {
    id: "en_cours",
    libelle: "Demande commencée",
    description: "La première étape du formulaire n'est pas terminée.",
    ton: "neutre",
    icone: "fa-pencil-alt",
  },
  estimee: {
    id: "estimee",
    libelle: "Demande à finaliser",
    description: "Première étape du formulaire terminée, la seconde (devis prêt à signer) ne l'est pas.",
    ton: "attention",
    icone: "fa-hourglass-half",
  },
  finalisee: {
    id: "finalisee",
    libelle: "Demande finalisée",
    description: "Seconde étape terminée : dossier complet.",
    ton: "ok",
    icone: "fa-check-circle",
  },
};

export function progressionDemande(lead = {}) {
  if (lead.isFinalized) return PROGRESSIONS.finalisee;
  if (lead.isEstimated) return PROGRESSIONS.estimee;
  return PROGRESSIONS.en_cours;
}
